module.exports = __webpack_public_path__ + "static/media/flaming-football.428e5af2.png";